import contracts from '@/api/contracts'

const getBaseState = () => ({
  list: [],
  metrics: {},
  histories: {},
  loansRepartition: [],
  loansAccountsRepartition: [],
  completeHistory: {},
  composition: {}
})

export default () => ({
  namespaced: true,

  state: getBaseState(),

  actions: {
    fetch (context, cached = true) {
      const { list } = context.state
      if (cached && list.length) {
        return Promise.resolve(list)
      }

      return contracts.fetchLoans()
        .then(data => {
          context.commit('fetch', data)
        })
    },

    fetchLoansComposition (context, cached) {
      if (cached && context.state.loansRepartition.length) {
        return Promise.resolve()
      }
      return contracts.fetchComposition('loan', 'kind')
        .then(({ data }) => context.commit('fetchComposition', data))
    },

    fetchLoansRepartition (context, cached) {
      if (cached && context.state.loansAccountsRepartition.length) {
        return Promise.resolve()
      }
      return contracts.fetchComposition('loan', 'bank')
        .then(({ data }) => context.commit('fetchRepartition', data))
    },

    fetchCompleteHistory (context, { cached = true, subset = 'loan' }) {
      if (cached && context.state.completeHistory[subset]) {
        return Promise.resolve()
      }
      return contracts.fetchCompleteHistory(subset)
        .then(data => context.commit('fetchCompleteHistory', { data, subset }))
    },

    fetchHistory (context, { subset = 'loan', from, cached = true }) {
      if (cached && context.state.histories[subset]) {
        return Promise.resolve(context.state.histories[subset])
      }
      return contracts.fetchLoansHistory(subset, from)
        .then(history => {
          context.commit('fetchHistory', { subset, history })
          return history
        })
    },

    linkLoanToRealEstate (context, {loanId, realEstateId, shouldLink}) {
      return contracts.linkLoanToRealEstate(loanId, shouldLink ? realEstateId : null)
        .then(() => {
          context.dispatch('fetch', false)
          context.dispatch('realestates/fetchRealEstateById', {id: realEstateId, cached: false}, {root: true})
        })
    }
  },

  mutations: {
    fetch (state, data) {
      state.metrics = data.metrics
      const sorted = data.loans.sort((a, b) => (a.id < b.id)
        ? 1
        : ((b.id < a.id) ? -1 : 0))
      state.list = sorted
    },

    fetchComposition (state, data) {
      state.loansRepartition = data[0]
    },

    fetchRepartition (state, data) {
      state.loansAccountsRepartition = data
    },

    fetchCompleteHistory (state, { data, subset }) {
      state.completeHistory = {
        ...state.completeHistory,
        [subset]: data
      }
    },

    fetchHistory (state, { subset, history }) {
      state.histories = {
        ...state.histories,
        [subset]: history
      }
    },

    reset (state) {
      const baseState = getBaseState()
      Object.keys(baseState).forEach(key => {
        state[key] = baseState[key]
      })
    }
  },

  getters: {
    getLoansByKindDetail: ({ list }) => (kindDetail) => {
      const portfolios = [...(list.filter(portfolio => portfolio.kindDetail === kindDetail && portfolio.status !== 'hidden'))]
      return portfolios
    },

    getCumulativeValues: ({ list }) => (kindDetail, key) => {
      const portfolios = [...(list.filter(portfolio => (!kindDetail || portfolio.kindDetail === kindDetail) && portfolio.status !== 'hidden'))]
        .reduce((sum, {loan: {[key]: value}}) => sum + value, 0)
      return portfolios
    },

    getById: ({ list }) => (id) => {
      // Ignoring rule because sometimes our IDs are stored as strings,
      // sometimes as ints 🤷
      // eslint-disable-next-line eqeqeq
      return list.find(loan => loan.id == id)
    }
  }
})
